import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URLS } from '../config/api';

function ChurchSelect({
  value,
  onChange,
  required = false,
  id = 'churchId',
  name = 'churchId',
  className = '',
  disabled = false,
  excludeIds = [],
}) {
  const [churches, setChurches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function loadChurches() {
      try {
        const response = await axios.get(API_URLS.churches);
        if (!cancelled) {
          setChurches(response.data);
        }
      } catch (err) {
        if (!cancelled) {
          setError('Could not load churches');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadChurches();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <select
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        required={required}
        disabled={disabled || loading}
        className={className || 'mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-indigo-500'}
      >
        <option value="">
          {loading ? 'Loading churches...' : 'Select your home church'}
        </option>
        {churches
          .filter((church) => !excludeIds.includes(church.id))
          .map((church) => (
          <option key={church.id} value={church.id}>
            {church.name}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}

export default ChurchSelect;
